import { render, staticRenderFns } from "./face_begin.vue?vue&type=template&id=8f29abd0&scoped=true&"
import script from "./face_begin.vue?vue&type=script&lang=js&"
export * from "./face_begin.vue?vue&type=script&lang=js&"
import style0 from "./face_begin.vue?vue&type=style&index=0&id=8f29abd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f29abd0",
  null
  
)

export default component.exports